import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "./Spinner";
import { AuthContext } from "../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../style/odds.css";
import api_url from "../constants";

function BlockedUsers({ userData }) {
  const [authContext] = useContext(AuthContext);
  const config = {
    headers: { Authorization: `Bearer ${authContext.token}` },
  };
  const agentArr = [
    { id: "ad", name: "Super Admin" },
    { id: "cc", name: "Admin" },
    { id: "sc", name: "Super Company" },
    { id: "sst", name: "Super Stockist" },
    { id: "ss", name: "Stockist" },
    { id: "sa", name: "Agent" },
    { id: "sp", name: "Player" },
  ];

  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [limit, setLimit] = useState({});
  const [amount, setAmount] = useState("");
  const [downBalance, setDownBalance] = useState(0);
  const [loadingList, setLoadingList] = useState([]);
  const [dbLoading, setDbLoading] = useState(false);

  const fetchList = async () => {
    try {
      const response = await axios.get(`${api_url}/list/blocked`, config);
      setUserList(response.data);
      setDataLoading(false);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  const blockUser = async (username) => {
    await axios.post(
      `${api_url}/auth/blockUser/`,
      {
        username: username,
      },
      config
    );
    await fetchList();
  };
  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      if (limit.username) {
        const response = await axios.post(
          `${api_url}/coin/limitControl`,
          { type: limit.type, username: limit.username, amount },
          config
        );
        await fetchList();
        setLimit({});
        if (response.data && response.data.status) {
          await getDownBalance();
          toast.success(response.data.msg);
        } else {
          toast.error(
            response.data.msg ? response.data.msg : "Unknown Error Occurred"
          );
        }
      }
    } catch (error) {
      console.error("Error submitting:", error);
    }

    setAmount("");
    setSubmitLoading(false);
  };

  const getDownBalance = async () => {
    try {
      setDbLoading(true);
      const response = await axios.get(
        `${api_url}/coin/getDownBalance/${userData.details.username}`,
        config
      );
      setDownBalance(response.data.downBalance);
      setDbLoading(false);
    } catch (error) {
      console.error("Error getting down balance:", error);
    }
  };

  const getIndivisualDownBalance = async (username) => {
    try {
      setLoadingList([...loadingList, username]);
      const response = await axios.get(
        `${api_url}/coin/getDownBalance/${username}`,
        config
      );
      const updatedUserList = userList.map((user) => {
        if (user.username === username) {
          return {
            ...user,
            downBalance: response.data.downBalance,
          };
        }
        return user;
      });
      setUserList(updatedUserList);
      setLoadingList(loadingList.filter((user) => user !== username));
    } catch (error) {
      console.error("Error getting down balance:", error);
    }
  };

  const setLimitData = (type, username) => {
    setLimit({ type, username });
  };

  const removeNum = (text) => text && text.replace(/[0-9]/g, "");

  useEffect(() => {
    fetchList();
    getDownBalance();
  }, [userData]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {limit.username && (
        <div className="modal-body">
          <div className="modal-content">
            <div className="modal-header">
              Limit {limit.type === 1 ? "Plus" : "Minus"} ({limit.username})
            </div>
            <div className="modal-c" style={{ backgroundColor: "#fff" }}>
              <div>
                <input
                  autoComplete="off"
                  type="text"
                  placeholder="Amount"
                  id="amount"
                  inputMode="numeric"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-btn">
              <button onClick={handleSubmit}>
                {submitLoading ? (
                  <Spinner color={"#fff"} />
                ) : (
                  <span>Submit</span>
                )}
              </button>
              <button className="warn-btn" onClick={() => setLimit({})}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="header-container">
        <h1>Blocked Users</h1>
        <div>
          {" "}
          <Link to={"/"} className="tag-link">
            Dashboard
          </Link>{" "}
          / Blocked
        </div>
      </div>
      {agentArr.map((res) => {
        const filteredUserList = userList.filter(
          (x) => removeNum(x.username) === res.id
        );
        if (filteredUserList.length === 0) return null;

        return (
          <div
            className={`box-container ${
              dataLoading ? "fade-in" : "fade-in loaded"
            }`}
            key={res.id}
          >
            <div
              className={`box table ${
                dataLoading ? "fade-in" : "fade-in loaded"
              }`}
              style={{ maxWidth: "100%" }}
            >
              <div
                className="box-header"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>{res.name}</span>
              </div>
              <div className="box-body">
                <table style={{ width: "100%" }} className="normal">
                  <thead>
                    <tr>
                      <th className="center-th" colSpan={3}>
                        Client Commission
                      </th>
                      <th className="center-th" colSpan={3}>
                        Client Limit
                      </th>
                    </tr>
                    <tr>
                      <th>Username</th>
                      <th>Match Comm.</th>
                      <th>Ssn Comm.</th>
                      <th>{res.id === "pl" ? "Used Limit" : "Down Balance"}</th>
                      <th>Current Balance</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataLoading ? (
                      <tr colSpan="10">
                        <td colSpan={6}>
                          <Spinner color="#888" />
                        </td>
                      </tr>
                    ) : (
                      filteredUserList.map((data) => (
                        <tr key={data.id}>
                          <td
                            style={{
                              width: "max-content",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Link
                              to={`/userDashboard/${data.username}`}
                              style={{ width: "max-content" }}
                            >
                              {data.username} ({data.name?.trim()})
                            </Link>
                          </td>
                          <td>
                            <div>
                              <input
                                value={data.match_commission}
                                className="uneditable"
                                readOnly={true}
                              />
                            </div>
                          </td>
                          <td>
                            <div>
                              <input
                                value={data.session_commission}
                                className="uneditable"
                                readOnly={true}
                              />
                            </div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              {data.downBalance !== undefined ? (
                                parseFloat(data.downBalance).toFixed(2)
                              ) : (
                                <button
                                  style={{ minWidth: 90 }}
                                  className="pwd-btn"
                                  onClick={() =>
                                    getIndivisualDownBalance(data.username)
                                  }
                                >
                                  {loadingList.find(
                                    (user) => user === data.username
                                  ) ? (
                                    <Spinner />
                                  ) : (
                                    "Get Down Balance"
                                  )}
                                </button>
                              )}
                            </div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              {data.total_coins
                                ? Math.round(data.total_coins * 100) / 100
                                : 0}
                            </div>
                          </td>
                          <td>
                            <div className="table-flex">
                              <button
                                className="success-btn"
                                onClick={() => {
                                  setLimitData(1, data.username);
                                }}
                              >
                                LIMIT+
                              </button>
                              <button
                                className="warn-btn"
                                onClick={() => {
                                  setLimitData(0, data.username);
                                }}
                              >
                                LIMIT-
                              </button>
                              <button
                                onClick={() =>
                                  navigate(`/profitAndLoss/${data.username}`)
                                }
                              >
                                Agt.Profit
                              </button>
                              <button
                                onClick={() =>
                                  navigate(`/statementByUser/${data.username}`)
                                }
                              >
                                Coin History
                              </button>
                              <button
                                className="warn-btn"
                                onClick={() => {
                                  blockUser(data.username);
                                }}
                              >
                                UnBlock User
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default BlockedUsers;
